import { Icons } from "./icons";
import { Images } from "./images";

export const Assets = {
  icon: Icons,
  image: Images,
};
